export const getStorage = () => {
    return window.localStorage.getItem("access_token")
}

export const setStorage = (token) => {
    window.localStorage.setItem('access_token', token)
}

export const getStorageR = () => {
    return window.localStorage.getItem("refresh_token")
}

export const setStorageR = (token) => {
    window.localStorage.setItem('refresh_token', token)
}

export const clearStorage = () => {
    window.localStorage.removeItem('access_token')
    window.localStorage.removeItem('refresh_token')
}